// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"124":"b6c05ba8","461":"f34c326c","571":"d8e00c91","858":"760091ed"}[chunkId] + ".css";
};